import axios from "axios";

export const state = {
    registrationfees: [],
};

export const getters = {
    registrationfees: state => state.registrationfees,
};

export const mutations = {
    setRegistrationFees(state, newValue) {
        state.registrationfees = newValue
    },
};

export const actions = {
    async fetchRegistrationFees({ commit }) {
        await axios.get('/registrationfees').then(res => {
            commit('setRegistrationFees', res.data.registrationfees)
        })
    },
    async filterRegistrationFees({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterregistrationfees";
        await axios.post(url, formData).then((response) => {
            commit('setRegistrationFees', response.data.registrationfees)
        })
    },
};
